import { deserialize, fetchWrapper } from '../fetch';
import type { Run } from './interface';

export const runs = async (dossier_id: string): Promise<Run[]> => {
  const url = new URL(`/app/v1/runs/${dossier_id}`, API_BASE_URL);
  return deserialize(
    await fetchWrapper(url.href, { method: 'GET', credentials: 'include' })
  );
};
